export default {"src":"/_next/static/media/ic-discord-logo.a114704a.svg","height":240,"width":245};